import { cn } from "@/lib/utils";

type BadgeProps = {
  text: string;
  className?: string;
  backgroundColor?: string;
  textColor?: string;
};

export const CustomBadge = ({ text, className, backgroundColor, textColor }: BadgeProps) => {
  return (
    <span
      className={cn(
        "flex flex-col h-[22px] rounded-full justify-center items-center font-extrabold text-xs px-[15px]",
        className,
      )}
      style={{ backgroundColor, color: textColor }}
    >
      {text}
    </span>
  );
};
